import AccountStore from "../stores/AccountStore"
import AuthenticationStore from "../stores/AuthenticationStore"
import * as hierarchyHelper from "../helpers/hierarchyHelper"
import { ESuepervisorJobExplicitTypes, IWorkPoolEmployee, IPayTypeBudget } from "../models"
import strings from "../localization/strings"

export function getAllowJobByHierarchy(hierarchyId: string): boolean {
    const hierarchyDefinition = hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(hierarchyId)
    return hierarchyId ?
        hierarchyDefinition ?
            hierarchyDefinition.EnableJob :
            false :
        AccountStore.getCurrentAccountSettings().AllowJob
}

export function getShortListCandidates(workPoolEmployees: IWorkPoolEmployee[]): IWorkPoolEmployee[] {
    return workPoolEmployees ?
        workPoolEmployees.filter(item => item.ShortlistedUserIds.includes(AuthenticationStore.getLoggedInUser().Id)) :
        []
}

export function getSubmittedCandidates(workPoolEmployees: IWorkPoolEmployee[]): IWorkPoolEmployee[] {
    return workPoolEmployees ?
        workPoolEmployees.filter(item =>
            !item.ShortlistedUserIds.includes(AuthenticationStore.getLoggedInUser().Id) &&
            item.SubmittedById !== AuthenticationStore.getLoggedInUser().Id &&
            !item.EmployeeRequested &&
            !item.AutoMatched
        ) :
        []
}

export function getRequestedCandidates(workPoolEmployees: IWorkPoolEmployee[]): IWorkPoolEmployee[] {
    return workPoolEmployees ?
        workPoolEmployees.filter(item =>
            !item.ShortlistedUserIds.includes(AuthenticationStore.getLoggedInUser().Id) &&
            item.SubmittedById !== AuthenticationStore.getLoggedInUser().Id &&
            item.EmployeeRequested &&
            !item.AutoMatched
        ) :
        []
}

export function getAutoMatchedCandidates(workPoolEmployees: IWorkPoolEmployee[]): IWorkPoolEmployee[] {
    return workPoolEmployees ?
        workPoolEmployees.filter(item =>
            !item.ShortlistedUserIds.includes(AuthenticationStore.getLoggedInUser().Id) &&
            item.SubmittedById !== AuthenticationStore.getLoggedInUser().Id &&
            item.AutoMatched
        ) :
        []
}

export function getSupervisorAccessJobPermission(jobId: string): boolean {
    switch (AuthenticationStore.getLoggedInUser().JobExplicitTypes) {
        case ESuepervisorJobExplicitTypes.All:
            return true
        case ESuepervisorJobExplicitTypes.Include:
            return AuthenticationStore.getLoggedInUser().ExplicitJobIds.includes(jobId)
        case ESuepervisorJobExplicitTypes.Exclude:
            return !AuthenticationStore.getLoggedInUser().ExplicitJobIds.includes(jobId)
    }
}

export function getPayTypeId(isRegular: boolean, isOT: boolean, isOT2: boolean, payTypeId: string) {
    return (!isRegular && !isOT && !isOT2) ? payTypeId : null
}

export function checkSamePayTypeBudgetExist(isRegular: boolean, isOT: boolean, isOT2: boolean, payTypeId: string, budgetItem: IPayTypeBudget) {
    return isRegular === budgetItem.RegularTime && isOT === budgetItem.OTTime && isOT2 === budgetItem.OT2Time &&
        getPayTypeId(isRegular, isOT, isOT2, payTypeId) === getPayTypeId(budgetItem.RegularTime, budgetItem.OTTime, budgetItem.OT2Time, budgetItem.PayTypeId)
}

export function comparePayTypeBudgets(one: IPayTypeBudget, another: IPayTypeBudget) {
    return one.RegularTime === another.RegularTime && one.OTTime === another.OTTime && one.OT2Time === another.OT2Time &&
        getPayTypeId(one.RegularTime, one.OTTime, one.OT2Time, one.PayTypeId) === getPayTypeId(another.RegularTime, another.OTTime, another.OT2Time, another.PayTypeId)
}

export function getMilesFromClient(milesFromClient: number) {
    return milesFromClient === -3 ?
        strings.No_Job_location :
        milesFromClient === -2 ?
            strings.No_Employee_location :
            milesFromClient === -1 ?
                strings.Unknown :
                milesFromClient >= 0 ?
                    milesFromClient :
                    ""
}

export function checkJobFieldAvailable(position: "singular" | "plural") {
    if (AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels) {
        if (position === "plural") {
            if (AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel) {
                return true
            }
        } else if (position === "singular") {
            if (AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel) {
                return true
            }
            return false
        }

        return false
    }
    return false
}